import { render, staticRenderFns } from "./ChatMessageAttachmentComponent.vue?vue&type=template&id=2b8bb8b6&"
import script from "./ChatMessageAttachmentComponent.vue?vue&type=script&lang=js&"
export * from "./ChatMessageAttachmentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lpcms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b8bb8b6')) {
      api.createRecord('2b8bb8b6', component.options)
    } else {
      api.reload('2b8bb8b6', component.options)
    }
    module.hot.accept("./ChatMessageAttachmentComponent.vue?vue&type=template&id=2b8bb8b6&", function () {
      api.rerender('2b8bb8b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ChatMessageAttachmentComponent.vue"
export default component.exports